import { render } from "./AppLayout.vue?vue&type=template&id=f56b8558"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=f56b8558&lang=scss"
script.render = render

export default script